import { Component, OnDestroy, OnInit } from '@angular/core';
import { FacilityInformationType } from '@cargos/sprintpay-services';
import { Subject, of, switchMap, takeUntil } from 'rxjs';
import { ColumnsType } from 'src/app/shared/models/table-settings';
import { SessionService } from 'src/app/shared/services';
import { LocationService } from 'src/app/shared/services/locations.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();
    public columns: ColumnsType<FacilityInformationType>[];
    public displayedColumns: string[];
    public dataSource: FacilityInformationType[];

    constructor(
        private locationsService: LocationService,
        private sessionService: SessionService
    ) {}

    ngOnInit(): void {
        this.setFooterSettings();
        this.getFacilityLocations();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    setFooterSettings(): void {
        this.columns = [
            {
                columnDef: 'airport',
                header: 'Airport',
                cell: (element: FacilityInformationType) => `${element.airportCode || 'N/A'}`,
                pipe: 'date',
            },
            {
                columnDef: 'address',
                header: 'Address',
                cell: (element: FacilityInformationType) => `${element.address1 || 'N/A'}`,
                pipe: null,
            },
            {
                columnDef: 'phone',
                header: 'Phone',
                cell: (element: FacilityInformationType) => `${element.phone || 'N/A'}`,
                pipe: null,
            },
            {
                columnDef: 'firmsCode',
                header: 'Firms code',
                cell: (element: FacilityInformationType) => `${element.firmsCode || 'N/A'}`,
                pipe: null,
            },
        ];

        this.displayedColumns = this.columns.map((c) => c.columnDef);
    }

    getFacilityLocations(): void {
        this.sessionService
            .hasToken$()
            .pipe(
                switchMap((hasToken) => {
                    if (hasToken) {
                        return this.locationsService.getFacilityLocations();
                    }

                    return of([]);
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((information) => {
                this.dataSource = information;
            });
    }
}
